import React from 'react';
import { Modal } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { SMLCreationSheetBody } from './SMLCreationSheetBody';
import { SMLCreationSheetProps } from './props';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Making a smartlink, on web and Electron.
 *
 * It replaces two modals: one that asked what the artist wanted to make, and
 * one that then asked for the link that would have answered the first. The
 * body is mounted only while the sheet is open so every attempt starts clean.
 *
 * React Native keeps the old `SMLCreationModal`. The sheet leans on catalog
 * search, live resolution and a fourteen-swatch theme row, none of which the
 * mobile app has, and native creation is not worth breaking for it.
 */
const SMLCreationSheetComponent: React.FC<SMLCreationSheetProps> = ({
  accountId,
  isOpen,
  closeModal,
  initialCatalogTrackMaid,
  initialCatalogItemUuid,
}) => (
  // `contentClassName`, so the sheet is the modal's own surface rather than a
  // second framed box inside it: the app already themes `.modal-content`.
  <Modal isOpen={isOpen} toggle={closeModal} centered className={styles.dialog} contentClassName={styles.sheet}>
    {isOpen && (
      <SMLCreationSheetBody
        accountId={accountId}
        closeModal={closeModal}
        initialCatalogTrackMaid={initialCatalogTrackMaid}
        initialCatalogItemUuid={initialCatalogItemUuid}
      />
    )}
  </Modal>
);

export const SMLCreationSheet = TypedMemo(SMLCreationSheetComponent);
